import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import OtpInputGroupEN from 'components/OtpInputGroup/locales/OtpInputGroup_en_US';
import OtpInputGroupFR from 'components/OtpInputGroup/locales/OtpInputGroup_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;

const getText = getLocalisedDataFromResource(OtpInputGroupEN, OtpInputGroupFR);

const localization = createStructuredSelector({
    accessibilityOtpLegend: getTextFromResource(getText, 'accessibilityOtpLegend', ['{0}']),
    accessibilityOtpInput: getTextFromResource(getText, 'accessibilityOtpInput', ['{0}'])
});

const fields = createStructuredSelector({ localization });

const functions = {};

const withOtpInputGroupProps = wrapHOC(connect(fields, functions));

export {
    fields, functions, withOtpInputGroupProps
};
